/**
 * Instagram feed — Doctor+Mattress
 * The slide itself is pure CSS (animation on .insta-row). This script
 * pauses it when:
 *  - the pointer hovers the slider (desktop)
 *  - the user touches/scrolls it (mobile)
 *  - keyboard focus is inside it (accessibility)
 *  - the section is off screen (performance)
 */
(function () {
  'use strict';

  function initInstaSection(section) {
    var row = section.querySelector('.insta-row');
    if (!row) return;

    var state = { hover: false, touch: false, focus: false, visible: true };
    var touchTimer = null;

    function update() {
      var paused = state.hover || state.touch || state.focus || !state.visible;
      row.style.animationPlayState = paused ? 'paused' : 'running';
    }

    // Desktop hover (only on devices that really have hover)
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      row.addEventListener('mouseenter', function () { state.hover = true; update(); });
      row.addEventListener('mouseleave', function () { state.hover = false; update(); });
    }

    // Mobile touch
    section.addEventListener('touchstart', function () {
      if (touchTimer) clearTimeout(touchTimer);
      state.touch = true;
      update();
    }, { passive: true });

    section.addEventListener('touchend', function () {
      touchTimer = setTimeout(function () {
        state.touch = false;
        update();
      }, 1500);
    }, { passive: true });

    // Keyboard focus (tabbing through links)
    section.addEventListener('focusin', function () { state.focus = true; update(); });
    section.addEventListener('focusout', function () { state.focus = false; update(); });

    // Off-screen pause
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          state.visible = entry.isIntersecting;
          update();
        });
      }, { threshold: 0.05 });
      observer.observe(section);
    }
  }

  function init() {
    document.querySelectorAll('.insta-section').forEach(initInstaSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.insta-section');
    if (section) initInstaSection(section);
  });
})();